import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled.div({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'row',
  gap: '24px',
  justifyContent: 'end',
  marginBlock: '10rem',
});

export const DialogButton = styled(Button)(({ theme }) => ({
  borderRadius: '16rem',
  border: `2rem solid ${theme.defaultTheme.primaryColor}`,
  color: theme.defaultTheme.primaryColor,
  padding: '0 32rem',
  background: 'transparent',
}));
